<template>
  <div v-loading="infoLoading">
    <ContentHeader path-set-type="replace" />

    <div class="content-container">
      <!-- 订单基本信息 -->
      <div class="trade-order-block">
        <div class="order-name">{{ basePocInfo.pocName }}</div>
        <div class="order-time">
          <div>下单时间：{{ tradeApplyInfoVO.applyDate | parseTime }}</div>
          <div class="order-number">订单编号：{{ tradeApplyInfoVO.applyNumber }}</div>
        </div>
      </div>

      <!-- 一元换购参与资格 -->
      <div class="trade-order-block" style="display: flex; align-items: center">
        <div class="block-title">一元换购活动参与资格</div>
        <div style="margin-left: 50px">
          <el-switch
            disabled
            v-model="tradeApplyBaseVO.isStack"
            active-color="#409EFF"
            inactive-color="#C0CCDA"
          />
        </div>
        <div v-if="joinMsgShow" class="trade-join-msg">
          （门店一元换购活动参与资格已被关闭，无法重新开启）
        </div>
      </div>

      <!-- 禁用申请记录 -->
      <div v-if="isApprovalStatus" class="trade-order-block">
        <div style="color: #cd1231">已提交禁用申请，待上级审批</div>
        <el-row class="content-row">
          <BaseCell :value="tradeDCOFOptRequestDTO.requestClientName" label="禁用人" />
          <BaseCell :value="tradeDCOFOptRequestDTO.requestReasonName" label="禁用理由" />
        </el-row>
        <el-row class="content-row">
          <BaseCell :value="tradeDCOFOptRequestDTO.requestTime" label="提交时间" isTime />
          <BaseCell :value="tradeDCOFOptRequestDTO.requestRemark" label="补充备注" />
        </el-row>
      </div>

      <!-- 门店基本信息 -->
      <InfoCollapse infoTitle="门店基本信息">
        <div class="trade-order-block">
          <el-row class="content-row">
            <BaseCell :value="basePocInfo.pocName" label="门店名称" />
            <BaseCell :value="`${basePocInfo.channelName} - ${basePocInfo.subChannelName}`" label="渠道" />
          </el-row>
          <el-row class="content-row">
            <BaseCell :value="getImg(basePocInfo.pocOutsidePhotoUri)" label="门店照片" isImg allCell />
          </el-row>
          <el-row class="content-row">
            <BaseCell :value="detailAddress" label="门店地址" allCell />
          </el-row>
          <el-row class="content-row">
            <div id="content-map" />
          </el-row>
        </div>
      </InfoCollapse>

      <!-- 门店执行信息 -->
      <InfoCollapse infoTitle="门店执行信息">
        <div class="trade-order-block">
          <el-row class="content-row">
            <BaseCell :value="tradeApplyBaseVO.keyContactPerson" label="关键人姓名" />
            <BaseCell :value="tradeApplyBaseVO.keyContactPhone" label="关键人手机号" />
          </el-row>
          <el-row class="content-row">
            <BaseCell :value="tradeApplyBaseVO.wsL1Name" label="一批经销商" />
          </el-row>
        </div>
      </InfoCollapse>

      <!-- 操作记录 -->
      <InfoCollapse infoTitle="操作记录">
        <OrderProcessInfo :processRecordList="processRecordList" />
      </InfoCollapse>
    </div>
  </div>
</template>

<script>
import ContentHeader from "@/components/content-header"
import BaseCell from "@/components/base-cell"
import InfoCollapse from './components/info-collapse'
import OrderProcessInfo from './components/order-process-info'
import { commonUtils } from '@/utils/common'
export default {
  name: 'dcof-order-info',
  components: {
    ContentHeader,
    BaseCell,
    InfoCollapse,
    OrderProcessInfo
  },
  data() {
    return {
      infoLoading: false,
      applyId: '',
      orderInfo: {},
      basePocInfo: {},
      tradeApplyInfoVO: {},
      tradeApplyBaseVO: {},
      tradeDCOFOptRequestDTO: {},
      processRecordList: []
    };
  },
  computed: {
    // 是否正在审核状态
    isApprovalStatus() {
      return this.tradeApplyBaseVO.isStack && this.tradeApplyInfoVO.waitDisableFlag
    },

    detailAddress() {
      const { provinceName, cityName, countyName, detailAddress } = this.basePocInfo
      return `${provinceName || ''}${cityName || ''}${countyName || ''}${detailAddress || ''}`
    },

    joinMsgShow() {
      if (this.processRecordList.length && this.processRecordList.length > 2) {
        const length = this.processRecordList.length - 2
        const { processAction, processReason } = this.processRecordList[length]
        return !this.tradeApplyBaseVO.isStack && processAction === '10' && processReason !== '03'
      }
      return false
    }
  },
  created() {
    this.getOrderInfo()
  },
  methods: {
    // 查询订单详情
    async getOrderInfo() {
      this.infoLoading = true
      const { data } = await this.$store.dispatch("getOrderInfo", this.$route.query.applyId)
      this.infoLoading = false;
      if (data.resultCode === '0') {
        this.orderInfo = data.resultData.tradeApplyOrderVO
        this.basePocInfo = this.orderInfo.basePocInfo || {}
        this.tradeApplyInfoVO = this.orderInfo.tradeApplyInfoVO || {}
        this.tradeApplyBaseVO = this.orderInfo.tradeApplyBaseVO || {}
        this.tradeDCOFOptRequestDTO = this.orderInfo.tradeDCOFOptRequestDTO || {}
        this.processRecordList = this.orderInfo.processRecordList || []

        this.tradeApplyBaseVO.isStack = Boolean(this.tradeApplyBaseVO.isStack)
        this.initPocAddressMap()
      }
    },

    initPocAddressMap() {
      const { locLatitude, locLongitude, pocName } = this.basePocInfo

      if (!locLatitude || !locLongitude) return
      const map = new AMap.Map('content-map', {
        center: [locLongitude, locLatitude],
        zoom: 16
      })
      const position = new AMap.LngLat(locLongitude, locLatitude)
      const marker = new AMap.Marker({position, map})
      const handleMapClick = AMap.Event.addListener(map, 'click', () => {
        window.open(`https://uri.amap.com/marker?position=${locLongitude},${locLatitude}&name=${pocName}&src=尊享先锋订单平台`)
      })
    },

    getImg(uri) {
      return commonUtils.getImageUrl(uri)
    }
  },
};
</script>

<style lang="scss" scoped>
.content-container {
  padding-bottom: 20px;

  .order-name {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .order-time {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .content-row {
    margin-top: $content-middle;
  }

  #content-map {
    width: 450px;
    height: 180px;
    border-radius: 8px;
    cursor: pointer;
  }

  .trade-join-msg {
    color: #999;
    margin-left: 30px;
    font-size: 12px;
  }
}
</style>
